<div class="full-page-container">
  <fgb-banner [title]="'contact.us.page.title' | translate"></fgb-banner>s

  <div class="d-block d-lg-none">
    <fgb-page-header
      [pageTitle]="'contact.us.page.title'"
      [backButtonLink]="'/'"
      [showBalance]="false"
      [showQr]="false"
    ></fgb-page-header>
  </div>
  <fgbcl-contact-us></fgbcl-contact-us>
</div>
